<div class="wrapper">
  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">GENERACIÓN DE DOCUMENTO</h1>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    @if (!readyToSign) {
    <form name="entrar" [formGroup]="documentForm" (ngSubmit)="onSubmit()" class="formulario form-gen-doc"
      autocomplete="off">
      <div class="row documento">
        @if (signerAdressee!=null) {
        <div class="info-destinatario">
          <h2 class="tp-navandu"> INFORMACIÓN DEL DESTINATARIO </h2>
          <div class="flex-row info-dest">
            <mat-form-field>
              <mat-label>Nombre</mat-label>
              <input matInput disabled>{{signerAdressee.name}}
            </mat-form-field>
            <mat-form-field class="email">
              <mat-label>Móvil</mat-label>
              <input matInput disabled>{{signerAdressee.phone}}
            </mat-form-field>
            <mat-form-field class="email">
              <mat-label>Email</mat-label>
              <input matInput disabled>{{signerAdressee.email}}
            </mat-form-field>
          </div>
        </div>
        }
      </div>
      <div class="documento">
        @if (template.content != undefined) {
        <div class="borrador">
          <h1>{{template.name}}</h1>
          <div [innerHTML]="template.content | safeHtml"></div>
        </div>
        }
        <div class="enviar">
          <input type="submit" class="boton" value="Enviar" [disabled]="buttonDisable">
        </div>
      </div>
    </form>
    } @else {
    <div class="documento firmar">
      <h2>Documento generado ir a firmar</h2>
      <button (click)="sign()" class="boton">FIRMAR</button>
    </div>
    }
    }
  </div>
</div>